// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--Fz2Gc","present-info":"_7a3fb80146--present-info--IaA61"};